import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PenLine } from "lucide-react";
import { http, img } from "@/lib/api";
import { Card, Stars } from "@/components/Reviews";

export default function ReviewsPage() {
  const [d, setD] = useState(null), [ph, setPh] = useState(null);
  useEffect(() => { document.title = "Client reviews · REVASTRA"; http.get("/reviews", { params: { limit: 100 } }).then((r) => setD(r.data)).catch(() => setD({ items: [], count: 0 })); }, []);
  return (
    <div className="max-w-[1500px] mx-auto px-4 lg:px-10 py-14" data-testid="reviews-page">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div><p className="eyebrow text-[var(--rose-deep)]">Client reviews</p><h1 className="serif text-4xl sm:text-5xl lg:text-6xl mt-2">Worn, rewoven, loved</h1>
          {!!d?.count && <p className="mt-3 text-sm flex items-center gap-2" data-testid="reviews-page-avg"><Stars n={Math.round(d.avg)} /> {d.avg} out of 5 · {d.count} review{d.count > 1 ? "s" : ""}</p>}</div>
        <Link to="/review" className="btn btn-ox" data-testid="reviews-page-write"><PenLine className="w-4 h-4" /> Write a review</Link>
      </div>
      {d && (d.items.length ? <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-5 [&>article]:w-full" data-testid="reviews-grid">{d.items.map((r) => <Card key={r.id} r={r} onPhoto={setPh} />)}</div>
        : <p className="mt-8 text-[var(--taupe)]" data-testid="reviews-page-empty">No reviews yet. Be the first to share how you styled it.</p>)}
      {ph && <div className="fixed inset-0 z-[90] bg-black/85 flex items-center justify-center p-6" onClick={() => setPh(null)} data-testid="reviews-page-photo"><img src={img(ph)} alt="Customer photo" className="max-h-[88vh] max-w-full rounded-2xl" /></div>}
    </div>
  );
}
